import type { ReactNode } from 'react';

/**
 * Coming-Soon stub — 1:1 with the mockup's `.dash-schedule-stub` (Schedule,
 * Billing): a centered card with a muted 48px icon, title, sub-text and an
 * optional action button.
 */
export function ComingSoon({
  icon,
  title,
  body,
  action,
}: {
  icon: string;
  title: string;
  body: string;
  action?: ReactNode;
}) {
  return (
    <div className="card" style={{ maxWidth: 560, margin: '8px auto 0' }}>
      <div className="dash-schedule-stub">
        <span aria-hidden dangerouslySetInnerHTML={{ __html: icon }} />
        <div className="dash-schedule-stub-title">{title}</div>
        <div className="dash-schedule-stub-sub">{body}</div>
        {action}
      </div>
    </div>
  );
}

const wrap = (p: string) =>
  `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${p}</svg>`;
export const CS_ICONS = {
  calendar: wrap(
    '<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  ),
  billing: wrap(
    '<rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>',
  ),
};
